import { FormControl } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import FiltroStore from '../../../store/FiltroStore';
import AutoComplete from '../../../misc/AutoComplete';
import FiltroImportacaoStore from '../../../store/FiltroImportacaoStore';
import { IAutocomplete } from '../../../modelo/Autocomplete';

interface IPropsFiltroClasse {
    importacao?: boolean;
    /** Sobrescreve a origem padrão das opções (processos do escaninho) — usado em telas sem processos carregados, como Minutas Assinadas. */
    options?: IAutocomplete<string>[];
}


class FiltroClasse extends React.Component<IPropsFiltroClasse> {
    importacaoLocal = false;

    constructor(props: IPropsFiltroClasse) {
        super(props);

        this.importacaoLocal = !!props.importacao;

        makeObservable(this, {
            importacaoLocal: observable,
            callback: action
        });
    }

    componentDidUpdate(prevProps: IPropsFiltroClasse) {
        if (prevProps.importacao !== this.props.importacao) {
            this.importacaoLocal = !!this.props.importacao;
        }
    }

    get store() {
        return this.importacaoLocal ? FiltroImportacaoStore : FiltroStore;
    }

    get opcoes(): IAutocomplete<string>[] {
        return this.props.options || this.store.classesUnicasFormatoAutoComplete;
    }

    callback = (ev, valores: IAutocomplete<string>[]) => {
        this.store.classeProcessoFilter = [];
        valores.forEach(valor => {
            this.store.classeProcessoFilter.push(valor.valor)
        });
    };

    render() {
        return (
            <FormControl fullWidth className='formControlFiltros'>
                <AutoComplete
                    multiple
                    freeSolo
                    callback={this.callback}
                    options={this.opcoes}
                    defaultValue={this.opcoes.filter(
                        (item) => {
                            return this.store.classeProcessoFilter.find(classe => classe === item?.texto)
                        }
                    )}
                    label='Classe'
                    id='filtroClasse'
                    apresentarTextoSecundario
                    white={true}
                />
            </FormControl>
        )
    }
}

export default observer(FiltroClasse);
